import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function addEvent(data) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}events/`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
    data,
  })
}

export function bulkCreateEvent(data) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}events/bulk/`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
    data,
  })
}

export function bulkCreateEventStatus(uuid) {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}events/bulk/${uuid}/`,
    headers: {
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getEventBySlug(event_slug) {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}events/admin/${event_slug}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function putEvent(event_slug, data) {
  return Vue.axios({
    method: "PUT",
    url: `${siteConfig.siteURL}events/${event_slug}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
    data,
  })
}

export function getContests(search_query) {
  return Vue.axios({
    method: "GET",
    url: `${
      siteConfig.siteURL
    }assignments/?fetch_active_contests=0&type=contest&include_path=1&pagination=false${
      search_query ? `&search=${search_query}` : ""
    }`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getEventContests(search_query) {
  return Vue.axios({
    method: "GET",
    url: `${
      siteConfig.siteURL
    }events/?event_type=contest&active_only=0&pagination=false${
      search_query ? `&search=${search_query}` : ""
    }`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getCohorts(search_query) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}cohorts/?pagination=false${
      search_query ? `&search=${search_query}` : ""
    }`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function fetchAssignmentById(assessment_id) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}assignments/${assessment_id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function archiveLiveclass(id) {
  return Vue.axios({
    method: "delete",
    url: `${siteConfig.siteURL}events/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getLiveclasses(search_query) {
  return Vue.axios({
    method: "get",
    url: `${
      siteConfig.siteURL
    }events/?active_only=0&event_type=liveclass&pagination=false${
      search_query ? `&search=${search_query}` : ""
    }`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
